export const APP_STORE_URL = import.meta.env.VITE_APP_STORE_URL || 'https://apps.apple.com';
export const SUPPORT_EMAIL = 'support@plumme.ru';
export const INFO_EMAIL = 'info@plumme.ru';
export const SUPPORT_TELEGRAM = 'https://t.me/plumme_support_bot';

// Ссылка на почту с предустановленной темой и текстом
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}?subject=Запрос_информации&body=Здравствуйте!%20Хотел%20бы%20уточнить%20...`;
